import React from 'react';
import { withTranslate } from 'shared/hocs/withTranslate';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from './TitleDivider.css';

class TitleDivider extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    position: PropTypes.oneOf(['left', 'center', 'right']),
    h1: PropTypes.bool,
    divider: PropTypes.bool,
    className: PropTypes.string,
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    position: 'left',
    className: 'mrb-30',
    divider: true,
    h1: false,
  };
  render() {
    const { t, divider, position, className, h1 } = this.props;
    const title = t(this.props.title);
    return (
      <div className={`${s.root} ${className}`}>
        {divider && position !== 'left' && <div className={`${s.divider} ${s.dividerLeft}`} />}
        {h1 &&
          <h1 className={s.h1}>
            {title}
          </h1>}
        {!h1 &&
          <p className={s.title}>
            {title}
          </p>}
        {divider && position !== 'right' && <div className={s.divider} />}
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(TitleDivider));



// WEBPACK FOOTER //
// ./src/shared/components/Article/TitleDivider/TitleDivider.js